import React from 'react';
import { Link } from 'react-router-dom';
import { COMPANY, NAV_LINKS, SERVICES } from '../constants/data';
import styles from './Footer.module.css';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        {/* Col 1 – Marka */}
        <div className={styles.brand}>
          <Link to="/" className={styles.logoWrap}>
            <img
              src={`${process.env.PUBLIC_URL}/logo-symbol.png`}
              alt="EMK Asansör"
              style={{ height: 36, width: 'auto' }}
            />
            <div>
              <div className={styles.logoName}>{COMPANY.name.toUpperCase()}</div>
              <div className={styles.logoTag}>{COMPANY.slogan}</div>
            </div>
          </Link>
          <p className={styles.desc}>
            {COMPANY.founded}'dan bu yana İstanbul ve çevre illerde güvenli,
            kaliteli asansör çözümleri sunuyoruz.
          </p>
          <div className={styles.socials}>
            <a href={COMPANY.social.whatsapp} target="_blank" rel="noreferrer" aria-label="WhatsApp">💬</a>
            <a href={COMPANY.social.instagram} target="_blank" rel="noreferrer" aria-label="Instagram">📸</a>
            <a href={COMPANY.social.facebook}  target="_blank" rel="noreferrer" aria-label="Facebook">📘</a>
            <a href={COMPANY.social.linkedin}  target="_blank" rel="noreferrer" aria-label="LinkedIn">💼</a>
          </div>
        </div>

        {/* Col 2 – Sayfalar */}
        <div>
          <div className={styles.colTitle}>Sayfalar</div>
          {NAV_LINKS.map(({ label, path }) => (
            <Link key={path} to={path} className={styles.footerLink}>{label}</Link>
          ))}
        </div>

        {/* Col 3 – Hizmetler */}
        <div>
          <div className={styles.colTitle}>Hizmetlerimiz</div>
          {SERVICES.map(s => (
            <Link key={s.id} to="/hizmetler" className={styles.footerLink}>{s.title}</Link>
          ))}
        </div>

        {/* Col 4 – İletişim */}
        <div>
          <div className={styles.colTitle}>İletişim</div>
          <a href={`tel:${COMPANY.phone}`}      className={styles.contactLine}>📞 {COMPANY.phone}</a>
          <a href={`tel:${COMPANY.mobile.replace(/\s/g, '')}`} className={styles.contactLine}>📱 {COMPANY.mobile}</a>
          <a href={`mailto:${COMPANY.email}`}   className={styles.contactLine}>📧 {COMPANY.email}</a>
          <p className={styles.contactLine}>📍 {COMPANY.address}</p>
          <p className={styles.contactLine}>🕐 {COMPANY.workHours}</p>
        </div>
      </div>

      {/* Alt çizgi */}
      <div className={styles.bottom}>
        <span>© {year} {COMPANY.name}. Tüm hakları saklıdır.</span>
        <span>TSE · CE · ISO 9001:2015 Sertifikalı</span>
      </div>

      {/* Yapımcı kredisi */}
      <div className={styles.credit}>
        © {year}, <a href="https://kteknoloji.net.tr" target="_blank" rel="noreferrer" className={styles.creditLink}>KTeknoloji</a>
        {' '}– Türkiye'nin Lider Servis Sağlayıcısı. All rights reserved.
      </div>
    </footer>
  );
}
